import {payrollInheritedNode} from '../payroll-utils'
import {breakdownDetails, breakdownFormatters} from './breakdown-utils'
export function BreakdownNode(b, a){
  var p = payrollInheritedNode({},b, a)
  p.modificationRequest = ({type, value, reason, applied_date})=>{
    var modifiable_id = p.details.id
    if(typeof(modifiable_id)==='undefined') modifiable_id = null
    var auxiliar_id = p.details.auxiliar_id
    if(typeof(auxiliar_id)==='undefined') auxiliar_id = null
    return {
      url: '/modification',
      parameters: {
        modifiable_type: type,
        value: value,
        reason: reason,
        employee_payroll_config_id: p.context.employee.details.employee_payroll_config,
        modifiable_id: modifiable_id,
        auxiliar_id: auxiliar_id,
        applied_date: applied_date
      }
    }
  }
  p.deleteExtraOrDiscountRequest = {
    url: '/extra-or-discount/'+p.details.id,
    id: p.details.id
  }
  return p
}
